module.exports = __webpack_public_path__ + "static/media/online_shop.99d701a6.svg";